var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.572 2.02304H9.47962V0.578848C9.47962 0.34248 9.288 0.150879 9.05166 0.150879H0.427969C0.191625 0.150879 0 0.342504 0 0.578848V10.1608C0 11.0917 0.757477 11.849 1.68851 11.849H10.3119C11.2427 11.849 12 11.0917 12 10.1608V2.45101C12 2.21464 11.8084 2.02304 11.572 2.02304ZM1.68851 10.993C1.22946 10.993 0.855961 10.6197 0.855961 10.1608V1.00684H8.62366C8.62366 10.6292 8.5402 10.4602 8.84339 10.993H1.68851ZM11.144 10.1608C11.144 11.2606 9.47962 11.2606 9.47962 10.1608V2.879H11.144V10.1608Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51732 2.02319H1.96264C1.72627 2.02319 1.53467 2.21482 1.53467 2.45116V4.59886C1.53467 4.83522 1.72629 5.02683 1.96264 5.02683H7.51735C7.75372 5.02683 7.94532 4.8352 7.94532 4.59886V2.45116C7.94532 2.21479 7.75369 2.02319 7.51732 2.02319ZM7.08935 4.17087H2.39061V2.87915H7.08935V4.17087Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51732 6H1.96264C1.72627 6 1.53467 6.19163 1.53467 6.42797V8.57566C1.53467 8.81203 1.72629 9.00363 1.96264 9.00363H7.51735C7.75372 9.00363 7.94532 8.81201 7.94532 8.57566V6.42797C7.94532 6.1916 7.75369 6 7.51732 6ZM7.08935 8.14767H2.39061V6.85596H7.08935V8.14767Z",
    fill: "#3F3F3F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.9abc1591.svg";
export { ForwardRef as ReactComponent };